import { render, staticRenderFns } from "./BeginOrderView.vue?vue&type=template&id=4d8a3d90"
import script from "./BeginOrderView.vue?vue&type=script&lang=js"
export * from "./BeginOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports